import React, { memo, useState, useEffect, useRef } from "react";

const ImgComps = (props: {
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  className?: string;
  src?: string | null;
  style?: any;
}) => {
  const { className, src, style, onClick } = props;
  const [isError, setIsError] = useState(false);
  const imgRef = useRef<any>();
  const onImgError = (e: any) => {
    setIsError(true);
  };
  return (
    <div className={className} style={{ ...style, overflow: "hidden" }}>
      {src && (
        <img
          style={{
            display: !isError ? "block" : "none",
            width: "100%",
            height: "100%"
          }}
          src={src}
          onError={onImgError}
          ref={imgRef}
          onClick={(e: any) => {
            onClick?.(e);
          }}
        />
      )}
    </div>
  );
};

export default ImgComps;
